// extracted by mini-css-extract-plugin
export var bookTopMargin = "snapshot-module--book-top-margin--21617";